import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from 'app/selectors/AuthSelector';
import StaffTakeoverMessage from './StaffTakeoverMessage';

const StaffTakeoverContainer = () => {
  const currentUser = useSelector(selectCurrentUser);
  const name = currentUser?.get('name');
  const isStaffTakeover = currentUser?.get('staffTakeover');
  if (!(name && isStaffTakeover)) {
    return null;
  }

  return <StaffTakeoverMessage name={name} />;
};

export default StaffTakeoverContainer;
